import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import Footer from "../components/Footer";

const QUOTES = [
  "Une traversée douce et puissante à la fois.",
  "J’ai retrouvé un espace en moi que j’avais oublié.",
  "Le COCON m’a permis de respirer à nouveau.",
  "Un cercle où tout de moi était bienvenu.",
  "Je repars plus ancrée, plus claire, plus vivante.",
  "Les rituels, la nature, la présence : tout faisait sens.",
  "J’ai pu déposer ce que je portais depuis des années.",
  "Une expérience qui continue de vibrer dans mon quotidien.",
  "Je me suis sentie vue, entendue, accueillie.",
  "Un avant et un après COCON dans ma manière d’être au monde.",
  "Le groupe, le lieu, la guidance : une alchimie précieuse.",
  "Je repars avec des outils concrets et une confiance nouvelle.",
  "Le COCON m’a rappelé que je pouvais ralentir sans culpabilité.",
  "Je me sens reliée, même de retour chez moi.",
  "Une parenthèse sacrée, profondément humaine.",
  "Merci pour cet espace de vérité, de douceur et de courage." 
];

const Partages = () => {
  return (
    <div className="min-h-screen bg-[#F9F7F2] text-[#3F2A24]">
      {/* Header */}
      <header className="px-6 pt-8 pb-4">
        <div className="max-w-5xl mx-auto flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[#8C6A4A] hover:text-[#C5A059] transition-colors"
          >
            <span>Retour à la page d’accueil</span>
          </Link>
          <p className="text-xs tracking-[0.25em] uppercase text-[#8C6A4A]">
            Les coconé·e·s vous dévoilent tout
          </p>
        </div>
      </header>

      {/* Petite image d’ouverture */}
      <section className="px-6">
        <div className="max-w-5xl mx-auto overflow-hidden rounded-3xl shadow-sm">
          <img
            src="https://customer-assets.emergentagent.com/job_sacred-space-82/artifacts/igbs2t6o_%20-9.jpg"
            alt="Partages COCON"
            className="w-full h-48 md:h-56 object-cover"
          />
        </div>
      </section>

      {/* Grille de citations */}
      <section className="px-6 py-12">
        <div className="max-w-5xl mx-auto">
          {/* Premium micro-heading structure */}
          <div className="text-center mb-12 space-y-3">
            <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#C5A059]">
              Paroles vivantes
            </p>
            <h1 
              className="font-serif text-2xl sm:text-3xl text-[#3F2A24]"
              style={{ textWrap: 'balance' }}
            >
              LES PARTAGES DU COCON
            </h1>
            <p 
              className="font-serif text-sm text-[#3F2A24]/70 italic"
              style={{ textWrap: 'balance' }}
            >
              Ce que les coconé·e·s ont déposé
            </p>
            <div className="w-16 h-[1px] bg-[#C5A059]/50 mx-auto mt-3" />
            <p className="text-sm text-[#4B3329] pt-4 leading-[1.9]" style={{ textWrap: 'balance' }}>
              Une constellation de mots.<br />
              Chaque carte est un morceau de traversée,<br />
              à lire lentement, à laisser infuser.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {QUOTES.map((quote, index) => (
              <article
                key={index}
                className="relative group bg-[#F3E5CF] text-[#3F2A24] rounded-2xl p-4 text-sm leading-relaxed shadow-sm cursor-zoom-in overflow-hidden transition-transform duration-300 ease-out hover:scale-[1.04] hover:shadow-lg"
              >
                <p className="line-clamp-3 group-hover:line-clamp-none">
                  {quote}
                </p>
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-transparent group-hover:backdrop-blur-[1px]" />
                <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-[#8C6A4A]">
                  <Search className="w-4 h-4" />
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Partages;
